import React from "react";
import { KeyboardArrowDown } from "@mui/icons-material";
import { IconButton as MuiIconButton, styled, Tooltip } from "@mui/material";
import { blue } from "@mui/material/colors";
import classNames from "classnames";

const StyledIconButton = styled(MuiIconButton)(({ theme }) => ({
  borderRadius: `0 0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
  borderTop: "1px solid rgba(255, 255, 255, 0.12)",
  width: 28,
  height: 16,
  minHeight: 16,
  padding: 0,

  "&.active": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },

  "&.selected:not(.active)": {
    backgroundColor: blue[50],
    color: theme.palette.info.main,
  },

  "&:not(.active):not(.selected)": {
    backgroundColor: "inherit",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

interface ToggleOptionButtonProps {
  onClick: (e: React.MouseEvent) => void;
  active?: boolean;
  selected?: boolean;
  title?: string;
}

const ToggleOptionButton: React.FC<ToggleOptionButtonProps> = ({ onClick, active = false, selected = false, title = "Configure options" }) => {
  return (
    <Tooltip title={title}>
      <StyledIconButton size="small" onClick={onClick} className={classNames({ active, selected })}>
        <KeyboardArrowDown sx={{ fontSize: 14 }} />
      </StyledIconButton>
    </Tooltip>
  );
};

export default ToggleOptionButton;
